import { render } from "./Menu.vue?vue&type=template&id=a5e1bb24"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Menu.vue?vue&type=style&index=0&id=a5e1bb24&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__